import styled from "styled-components"

export default styled.time`
font-weight: 600;
color: #014fb0;
`
